class About {
  constructor(el,opt){
    this.el = el;
    this.flag = false;
    this.chartCreated = false; // フラグを追加
    if($("." + this.el).length > 0){
      this.event();
      this.initObserver();
    }
  }

  initObserver() {
    const optionsCircle = {
      threshold: 0.5  // カウンター要素がすべて画面に表示されたとき(= 1)
    };

    const observerCircle = new IntersectionObserver((entries) => {
      this.circleGraphAnime(entries);
    }, optionsCircle);

    observerCircle.observe(document.querySelector('.js-circle-graph'));


    const optionsLine = {
      threshold: 0.5  // カウンター要素がすべて画面に表示されたとき(= 1)
    };

    const observerLine = new IntersectionObserver((entries) => {
      this.lineGraphAnime(entries);
    }, optionsLine);

    observerLine.observe(document.querySelector('.js-line-graph'));
  }

  circleGraphAnime(entries) {

    entries.forEach(entry => {
      if(entry.intersectionRatio >= 0.05){

        setTimeout(() => {
          $('.js-circle-graph-txt').fadeIn();
        }, 1000);


        var ctx = document.getElementById('myPieChart').getContext('2d');
        var myPieChart = new Chart(ctx, {
          type: 'pie',
          data: {
            labels: ['Red', 'Red', 'Red', 'Red', 'Red', 'Red'], // Adding more labels for more slices
            datasets: [{
              label: '# of Votes',
              data: [22, 18, 15, 13, 18, 4], // All data points are equal
              backgroundColor: [
                'rgba(196, 28, 29, 1)',
                'rgba(219, 118, 119, 1)',
                'rgba(196, 28, 29, 1)',
                'rgba(219, 118, 119, 1)',
                'rgba(196, 28, 29, 1)',
                'rgba(219, 118, 119, 1)'
              ],
              borderColor: [
                'rgba(196, 28, 29, 1)',
                'rgba(219, 118, 119, 1)',
                'rgba(196, 28, 29, 1)',
                'rgba(219, 118, 119, 1)',
                'rgba(196, 28, 29, 1)',
                'rgba(219, 118, 119, 1)'
              ],
              borderWidth: 1
            }]
          },
          options: {
            responsive: true,
            plugins: {
              legend: {
                display: false
              },
              tooltip: {
                enabled: false
              }
            },
            animation: {
              duration: 1000, // Animation duration in milliseconds
              easing: 'easeOutCirc', // Easing function
              animateRotate: true, // Enable rotation animation
            }
          }
        });
        this.chartCreated = true; // フラグを設定して、チャートが作成されたことを示す
      }
    });
  }

  lineGraphAnime(entries) {
    let barThickness;
    if (window.matchMedia("(min-width:1101px)").matches) {
      barThickness = 87;
    } else {
      barThickness = 50;
    }

    entries.forEach(entry => {
      if(entry.intersectionRatio >= 0.05){

        setTimeout(() => {
          $('.js-line-graph-txt').animate({'opacity': '1'}, 500);
        }, 800);

        const ctx = document.getElementById('myBarChart').getContext('2d');
        const myBarChart = new Chart(ctx, {
          type: 'bar',
          data: {
            labels: ['', '', '', '', ''], // ラベルなし
            datasets: [{
              data: [3, 3.4, 4, 5, 7],
              backgroundColor: [
                'rgba(196, 28, 29, 0.4)',
                'rgba(196, 28, 29, 0.4)',
                'rgba(196, 28, 29, 0.4)',
                'rgba(196, 28, 29, 0.4)',
                'rgba(196, 28, 29, 1)'
              ], // 赤色
              barThickness: barThickness // バーの幅を30に設定
            }]
          },
          options: {
            plugins: {
              legend: {
                display: false // データセットのラベルを表示しない
              }
            },
            scales: {
              y: {
                beginAtZero: true,
                grid: {
                  display: false // 背景の線を表示しない
                },
                border: {
                  display: false // y軸の境界線を非表示にする
                },
                ticks: {
                  display: false // 目盛りを表示しない
                }
              },
              x: {
                grid: {
                  display: false // 背景の線を表示しない
                },
                ticks: {
                  display: false // 目盛りを表示しない
                }
              }
            }
          }
        });
      }
    });
  }

  event(){
    if (window.matchMedia("(min-width:1101px)").matches) {
      $('.js-trigger > div').click(
        function() {
          if(!$('.js-change > img').eq($(this).index()).hasClass('is-active')) {
            $('.js-change > img').removeClass('is-active');
            $('.js-change > img').css({'display': 'none'});
            $('.js-change > img').eq($(this).index()).addClass('is-active');
            $('.js-change > img').eq($(this).index()).fadeIn();
          }
        }
      );
  
      $('.js-toggle-trigger').click(
        function() {
          var isActive = $(this).find('.js-toggle-inner').is(':visible');
  
          // すべてのアコーディオンを閉じる
          $('.js-toggle-inner').fadeOut(1);
          $('.js-toggle-cls').removeClass('is-active');
  
          // 現在の要素がもともと閉じていた場合のみ開く
          if (!isActive) {
            $(this).find('.js-toggle-inner').fadeToggle();
            $(this).find('.js-toggle-cls').toggleClass('is-active');
          }
        }
      );
    } else {
      $('.js-toggle-accordion').click(function() {
        var isActive = $(this).next().is(':visible');
  
        // 他の開いているアコーディオンを閉じる
        $('.js-toggle-accordion').not(this).find('.js-toggle-cls').removeClass('is-active');
        $('.js-toggle-accordion').not(this).next().slideUp();
  
        // 現在の要素がもともと閉じていた場合のみ開く
        $(this).find('.js-toggle-cls').toggleClass('is-active');
        $(this).next().slideToggle();
      });
    }
  }
    
}
class Entry {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }

  event() {
    if (this.getUrlParam('work')) {
      document.querySelector(`[value="${this.getUrlParam('work')}"]`).checked = true;
    }

    setTimeout(() => {
      $('.js-occupation-radio').eq(0).prop('checked', true);
    }, 300);
    val_change($('.js-occupation-radio').eq(0));

    function val_change(el) {
      $(`[name="${el.attr('data-name')}"]`).val(el.attr('value'));
    }

    $('.js-occupation-radio').change(function() {
      val_change($(this));
    })

    $('.js-occupation-trigger input[type="radio"]').change(function() {
      let radio = $(this);
      let trueEl = true;
      $('.js-occupation-radio').each(function(index, el) {
        if($(el).attr('data-cat') == radio.val()) {
          $(el).parent().parent().css({'display':'block'});
          if(trueEl == true) {
            $(el).prop('checked', true);
            val_change($(el));
            trueEl = false;
          }
        } else {
          $(el).parent().parent().css({'display':'none'});
        }
      })
    })
  }
  
  getUrlParam(param) {
    // クエリストリングを取得し、パラメータを分解
    var pageUrl = window.location.search.substring(1);
    var urlVariables = pageUrl.split('&');
    
    // 各パラメータをループして目的のパラメータを探す
    for (var i = 0; i < urlVariables.length; i++) {
        var parameterName = urlVariables[i].split('=');
        
        // 指定されたパラメータが見つかった場合、その値を返す
        if (parameterName[0] === param) {
            return parameterName[1] === undefined ? true : decodeURIComponent(parameterName[1]);
        }
    }
    
    // 指定されたパラメータが見つからない場合、nullを返す
    return null;
  }
}
class Interview {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    // Swiperのインスタンスを保持する変数
    let swiperInstance;

    // Swiperを初期化する関数
    let swiperTouchStartX;

    const scrollbar = document.querySelector("#js-slider__scroll");
    const scrollbar_growbar = document.querySelector("#js-slider__scrollGrowbar");
  
    var scrollbar_w;
    var scrollbar_drag_w;
    var progress_range;

    swiperInstance = new Swiper('.interview-swiper', {
      slidesPerView: 1.1,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      speed: 500, // スライドの速度をミリ秒単位で指定
      loop: true, // ループモードを有効にする
      navigation: {
        nextEl: `.swiper-button--next`,
        prevEl: `.swiper-button--prev`,
      },
      grabCursor: true,
      scrollbar: {
        el: scrollbar,
        draggable: true,
      },
      breakpoints: {
        // スライドの表示枚数：768px以上の場合
        768: {
          slidesPerView: 3.6,
        }
      },
      on: {
        init(swiper) {
          // スライド総数
          const totalSlidesLen = swiper.slides.length;
        },
        /**
         * Swiper上でドラッグされ始めたときの処理
         */
        touchStart(swiper, e) {
          /**
           * タッチされたX座標を保存
           * タッチ時とクリック時でイベントの返り値が変わるため処理を分岐
           */
          if (e.type === 'touchstart') {
            swiperTouchStartX = e.touches[0].clientX;
          } else {
            swiperTouchStartX = e.clientX;
          }
        },
        /**
         * Swiper上でドラッグし終わったときの処理
         */
        touchEnd(swiper, e) {
          // スワイプ判定のしきい値
          const tolerance = 150;
          // スライド総数
          const totalSlidesLen = swiper.slides.length;
    
          // 左にスワイプしたか右にスワイプしたかを判定
          const diff = (() => {
            if (e.type === 'touchend') {
              return e.changedTouches[0].clientX - swiperTouchStartX;
            } else {
              return e.clientX - swiperTouchStartX;
            }
          })();
    
          /**
           * タッチ開始時と、タッチ終了時のカーソルの座標を比較し、下記のどちらかに分岐させる。
           */
          // 最初のスライド上で左にスワイプされたときは最後のスライドに飛ばす
          if (swiper.isBeginning && diff >= tolerance) {
            swiper.slideTo(totalSlidesLen - 1);
          // 最後のスライド上で右にスワイプさせたときは最初のスライドに飛ばす
          } else if (swiper.isEnd && diff <= -tolerance) {
            // 一瞬待ってから最初のスライドに飛ばす
            // （少し遅らせないと、最初のスライドに戻った後に右スワイプ判定が走って2番目のスライドに飛ばされてしまうため）
            setTimeout(() => {
              swiper.slideTo(0);
            }, 1);
          }
        },
        resize: () => {
          scrollbar_w = scrollbar.clientWidth;
          scrollbar_drag_w = scrollbar.querySelector(".swiper-scrollbar-drag").clientWidth;
          gsap.to(scrollbar_growbar, {
            width: (scrollbar_w - scrollbar_drag_w) * progress_range + scrollbar_drag_w,
          });
        },
        progress: (swiper, progress) => {
          progress_range = progress;
          gsap.to(scrollbar_growbar, {
            width: (scrollbar_w - scrollbar_drag_w) * progress_range + scrollbar_drag_w,
          });
        },
      },
    });
    
    scrollbar_w = scrollbar.clientWidth;
    scrollbar_drag_w = scrollbar.querySelector(".swiper-scrollbar-drag").clientWidth;
  }
}

class Occupation {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

    if (window.matchMedia("(max-width:1100px)").matches) {
      let cls = 'swiper';

      $(`.${cls}`).each(function(index, el) {
        new Swiper(`.${cls + index}`, {
          slidesPerView: 1.1,
          centeredSlides: true,
          loop: true,
          // Navigation arrows
          navigation: {
            nextEl: `.swiper-button-next${index}`,
            prevEl: `.swiper-button-prev${index}`,
          },
        })
      })
    }


    let options = {
      threshold: [0],
      rootMargin: '-49.9%',
    }
    const observerEnter = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio > 0) {
          $(`[href="#${$(item).attr('id')}"]`).siblings().removeClass('is-active')
          $(`[href="#${$(item).attr('id')}"]`).addClass('is-active')
        } else {
          $(`[href="#${$(item).attr('id')}"]`).removeClass('is-active')
        }
      })
    }, options)

    const anchorEl = document.querySelectorAll('[id*="anchor"]')
    anchorEl.forEach((e)=>{
      observerEnter.observe(e)
    })
  }
}

class Recruitments {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }

  event() {
    let tabChange = this.tabChange.bind(this);
    $('.js-tab-trigger > div').click(function() {
      tabChange(this);
    });

    if (this.getUrlParam('tab')) {
      tabChange($('.js-tab-trigger > div').eq(this.getUrlParam('tab') - 1)[0]);
    }
  }

  tabChange(el) {
    el.classList.add('is-active');
    el.parentElement.querySelectorAll('div').forEach(sibling => {
      if (sibling !== el) sibling.classList.remove('is-active');
    });

    document.querySelectorAll('.tab-pane').forEach(pane => {
      pane.style.display = 'none';
    });
    document.getElementById('category-' + el.dataset.category).style.display = 'block';
  }
  
  getUrlParam(param) {
    // クエリストリングを取得し、パラメータを分解
    var pageUrl = window.location.search.substring(1);
    var urlVariables = pageUrl.split('&');
    
    // 各パラメータをループして目的のパラメータを探す
    for (var i = 0; i < urlVariables.length; i++) {
        var parameterName = urlVariables[i].split('=');
        
        // 指定されたパラメータが見つかった場合、その値を返す
        if (parameterName[0] === param) {
            return parameterName[1] === undefined ? true : decodeURIComponent(parameterName[1]);
        }
    }
    
    // 指定されたパラメータが見つからない場合、nullを返す
    return null;
  }
}
class PageTop {
  constructor(el, opt) {
    this.el = el;
    this.mvSwiperEle = '.js-mv-swiper';
    if ($(this.mvSwiperEle).length > 0) {
      this.mvSwiper();
    }
    this.newsTextSwiperEle = '.js-news-text-swiper';
    if ($(this.newsTextSwiperEle).length > 0) {
      this.newsTextSwiper();
    }
    this.newsSwiperEle = '.js-news-swiper';
    if ($(this.newsSwiperEle).length > 0) {
      this.newsSwiper();
    }
    this.mvTextEle = '.js-mv-text';
    if ($(this.mvTextEle).length > 0) {
      this.mvTextAnime();
    }
    this.ttlAnimeEle = '.js-ttl-anime';
    if ($(this.ttlAnimeEle).length > 0) {
      this.ttlAnime();
    }
  }
  mvSwiper() {
    new Swiper(this.mvSwiperEle, {
      loop: true,
      effect: "fade",
      allowTouchMove: false,
      speed: 1500,
      autoplay: {
        delay: 2000,
        disableOnInteraction: false,
      },
    })
  }
  newsTextSwiper() {
    new Swiper(this.newsTextSwiperEle, {
      loop: true,
      allowTouchMove: false,
      speed: 10000,
      slidesPerView: 'auto',
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
        reverseDirection: true
      },
      direction: 'horizontal', // 水平方向
    })
  }
  newsSwiper() {
    new Swiper(this.newsSwiperEle, {
      loop: true,
      allowTouchMove: false,
      speed: 7000,
      slidesPerView: 2,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
      },
      breakpoints: {
        '768': {
          slidesPerView: 4,
        }
      }
    })
  }
  mvTextAnime() {
    let $container = $('.js-mv-text');

    $container.each(function() {
      let html = $(this).html();
      let wrappedText = '';

      for (let i = 0; i < html.length; i++) {
        if (html[i] === '<' && html.substring(i, i + 4) === '<br>') {
          wrappedText += '<br>';
          i += 3; // skip the '<br>' tag
        } else {
          wrappedText += '<span style="display: inline-block;">' + html[i] + '</span>';
        }
      }
      $(this).html(wrappedText);
    });

    let tl = gsap.timeline();
    
    tl
    .fromTo(".js-mv-en", {
      opacity: 0,
      y: 20,
    },{
      opacity: 1,
      y: 0,
    })
    .to(".js-mv-text", 1,{
      opacity: 1,
    },)
    .fromTo(".js-mv-text span",{
      opacity: 0,
      y: 30,
      duration: 1500,
    },{
      opacity: 1,
      y: 0,
      stagger: 0.1 // スタグアニメーションの間隔
    },'<=')
  }
  ttlAnime() {
    let $container = $('.js-ttl-anime');

    $container.each(function() {
      let html = $(this).html();
      let wrappedText = '';

      for (let i = 0; i < html.length; i++) {
        if (html[i] === '<' && html.substring(i, i + 4) === '<br>') {
          wrappedText += '<br>';
          i += 3; // skip the '<br>' tag
        } else {
          wrappedText += '<span style="display: inline-block;">' + html[i] + '</span>';
        }
      }
      $(this).html(wrappedText);
    });

    let options = {
      threshold: [0.1]
    }
    const observerEnter = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target.querySelectorAll('span');
        if(entry.intersectionRatio >= 0.05 && !entry.target.classList.contains('is-active')){
          gsap.fromTo(item,{
            opacity: 0,
            y: 30,
            duration: 500,
          },{
            opacity: 1,
            y: 0,
            stagger: 0.1 // スタグアニメーションの間隔
          })
          entry.target.classList.add('is-active');
        }
      });
    }, options);

    const inviewItem = document.querySelectorAll('.js-ttl-anime');

    inviewItem.forEach((e)=>{
      observerEnter.observe(e);
    });
  }
}

// 参考サイト
// https://hacknote.jp/archives/15289/

let cookie = {
	/**
	 * 取得
	 * @param {string} cookieName 取得するCookieの名前
	 */
	get : function(cookieName) {
		if (!navigator.cookieEnabled) return false;

		var getCookieAllData  = document.cookie,
		    getCookieAllDatas = getCookieAllData.split(';'),
		    getCookieDatas    = {},
		    cookieKeyValue    = [],
		    cookieKey         = '',
		    cookieValue       = '';

		var hashLength = function(arr) {
			var result = 0, key = false;

			if (typeof arr !== 'object') return false;

			for (key in arr) result++;

			return result;
		};

		for (var i = 0, len = getCookieAllDatas.length; i < len; i++) {
			if (getCookieAllDatas[i] && getCookieAllDatas[i] !== '') {
				cookieKeyValue = getCookieAllDatas[i].split('=');
				cookieKey      = cookieKeyValue[0].replace(/^\s+/, '');
				cookieValue    = '';

				if (cookieKeyValue[1]) {
					cookieValue = decodeURIComponent(cookieKeyValue[1]);
				}

				getCookieDatas[cookieKey] = cookieValue;
			}
		}

		if (hashLength(getCookieDatas) > 0) {
			if (cookieName && cookieName in getCookieDatas) {
				return getCookieDatas[cookieName];
			} else {
				return getCookieDatas;
			}
		} else {
			return '';
		}
	},

	/**
	 * 設定
	 * @param {string} cookieName 設定するCookieの名前
	 * @param {string} value 設定する値
	 * @param {string} domain 有効ドメイン
	 * @param {string} path 有効パス
	 * @param {string} expires 有効期限
	 * @param {boolean} secure セキュアとするか
	 * @return {boolean} 設定に成功した場合はtrue、失敗した場合はfalseを返す
	 */
	set : function(cookieName, value, domain, path, expires, secure) {
		if (!navigator.cookieEnabled || !cookieName || !value) return false;

		var date, dt, ts, ts_after;

		var setCookieData = cookieName + '=' + encodeURIComponent(value) + ';';

		if (domain) setCookieData += 'domain=' + domain + ';';

		if (path) setCookieData += 'path=' + path + ';';

		if (expires) {
      dt = new Date();
      ts = dt.getTime();

      // 1時間後
      ts_after = ts + (1000 * 60 * 60 * expires);

      date = new Date(ts_after);
			setCookieData += 'expires=' + date.toGMTString() + ';';
		}

		if (secure && secure === true && location.protocol.match(/https/)) {
			setCookieData += 'secure';
		}

		document.cookie = setCookieData;

		return true;
	},

	/**
	 * 削除
	 * @param {string} cookieName 削除するCookieの名前
	 * @return {boolean} 削除に成功した場合はtrue、失敗した場合はfalseを返す
	 */
	del : function(cookieName) {
		if (!navigator.cookieEnabled || !cookieName) return false;

		var getCookieDatas = this.get();

		if (getCookieDatas[cookieName]) {
			var setCookieData = cookieName + '=;',
			    date          = new Date(0);

			setCookieData += 'expires=' + date.toGMTString() + '';

			document.cookie = setCookieData;

			return true;
		}

		return false;
	}
};
class FormConvert {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    //全角から半角
    function replaceZtoH(str){
      str = str.replace(/[！-～]/g, function(s){
        return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
      });
      str = str.replace(/[-－﹣−‐⁃‑‒–—﹘―⎯⏤ーｰ─━]/g, '-');
      return str;
    }
    const el = document.querySelector('.js-convert');
    el.addEventListener('blur', () => {
      const br = el.value;
      const ar = replaceZtoH(br);
      el.value = ar;
    });
  }
}

class FormErrorTxtControl {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }

  event() {
    $('.wpcf7-form-control').closest('.c-more-btn').click(function() {
      $('.wpcf7-not-valid-tip').css({'display': 'block'});
      let timeOut = setInterval(() => {
        if($('.wpcf7-not-valid-tip').length) {
          $('.wpcf7-not-valid-tip').css({'display': 'block'});
          clearInterval(timeOut);
        }
      }, 100);
    })
  }
}
class HeaderMenuFixed {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }
  event() {
    const MvSwiper = '.js-mv';

    // ScrollTrigger を作成
    Alpine.store('isHeaderReady', false);
    Alpine.store('isHeaderActive', false);

    ScrollTrigger.create({
      trigger: "body",
      start: "+=200",
      end: "+=500",
      onEnter: () => {
        Alpine.store('isHeaderReady', true);
      },
      onLeaveBack: () => {
        Alpine.store('isHeaderReady', false);
      },
    });
    ScrollTrigger.create({
      trigger: MvSwiper,
      start: 'bottom top',
      end: 'bottom bottom',
      onEnter: () => {
        Alpine.store('isHeaderActive', true);
      },
      onLeaveBack: () => {
        Alpine.store('isHeaderActive', false);
      },
    });
  }
}

// ------------------------------------------
// imgタグに「js-parallax」クラス、そのimgタグに要素をラップしてheightを指定すると、画像がはみ出た分が動く
// 「data-scrub」属性に数字を入れると、動きの滑らかさが変わる
// ------------------------------------------
class ImgParallax {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    let cls = this.el;
    let para_ele = document.querySelectorAll("." + this.el);
    para_ele.forEach((ele, index)=> {
      let property,scrub;

      $(ele).css({
        'object-fit':'cover',
        'object-position':'50% 0%',
        'width':'100%',
        'height':'100%',
      })

      property = '50% 100%';
      scrub = $(ele).data('scrub') ? $(ele).data('scrub') : 3;

      ele.classList.add(cls + index);
      gsap.to('.' + cls + index, {
        objectPosition: property,
        scrollTrigger: {
          trigger: '.' + cls + index, // 要素がビューポートに入ったときにアニメーション開始
          start: 'top bottom',
          end: 'bottom top',
          scrub: scrub,
          merker: true,
        }
      })
    })
  }
}

class InviewEvent {
  constructor(el, opt){
    $('.js-load-inview').animate({'opacity': '1'});
    this.el = "." + el;
    this.all = this.el + '-all';
    this.eachUp = this.el + '-each';
    this.eachItem = this.el + '-eachItem';
    this.eachItemFast = this.el + '-eachItem-fast';
    this.eachItemDelay = this.el + '-eachItem-delay';
    if($(this.el).length > 0){
      this.event();
    }
  }
  event() {
    let options = {
      threshold: [0, 0.05, 0.1, 1]
    }
    let optionsAll = {
      threshold: [0, 0.9, 1]
    }
    const observerEnter = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio >= 0.05){
          item.classList.add('is-inview');
          if(item.classList.contains('js-inview-each')){
            this.inviewEachUp(item);
          }
          if(item.classList.contains('js-inview-lottie')){
            this.inviewLottie(item);
          }
          observerEnter.unobserve(item);
        }
      });
    }, options);
    const observerAll = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio >= 0.9){
          item.classList.add('is-inview');
          if(item.classList.contains('js-inview-each')){
            this.inviewEachUp(item);
          }
          observerAll.unobserve(item);
        } else {
          item.classList.remove('is-inview');
        }
      });
    }, optionsAll);
    const inviewItem = document.querySelectorAll(this.el);
    const inviewAllItem = document.querySelectorAll(this.all);
    inviewItem.forEach((e)=>{
      observerEnter.observe(e);
    });
    inviewAllItem.forEach((e)=>{
      observerAll.observe(e);
    });
  }
  inviewEachUp(item){
    $(item).find(this.eachItem).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.2 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
    $(item).find(this.eachItemFast).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.1 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
    $(item).find(this.eachItemDelay).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.5 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
  }
  inviewLottie(item){
    if($(item).hasClass('js-lottie-flow')) {
      lottie.flow();
    }
    if($(item).hasClass('js-lottie-no01')) {
      lottie.no01();
    }
    if($(item).hasClass('js-lottie-no02')) {
      lottie.no02();
    }
    if($(item).hasClass('js-lottie-no03')) {
      lottie.no03();
    }
    if($(item).hasClass('js-lottie-no04')) {
      lottie.no04();
    }
    if($(item).hasClass('js-lottie-no05')) {
      lottie.no05();
    }
    if($(item).hasClass('js-lottie-no06')) {
      lottie.no06();
    }
    if($(item).hasClass('js-lottie-no07')) {
      lottie.no07();
    }
  }
}

class NumCountUp {
  constructor(el) {
    this.el = el;
    // 要素を取得して監視を開始する
    const items = document.querySelectorAll("." + this.el);
    this.initObserver(items);
  }

  initObserver(items) {
    const options = {
      threshold: 1  // カウンター要素がすべて画面に表示されたとき(= 1)
    };

    const observer = new IntersectionObserver((entries) => {
      this.shuffleNumberCounter(entries);
    }, options);

    items.forEach(target => {
      observer.observe(target);
    });
  }

  shuffleNumberCounter(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting && !entry.target.classList.contains('is-visible')) {
        const counterEle = entry.target;
        const from = parseFloat(entry.target.dataset.from || 0);
        const to = parseFloat(entry.target.dataset.to || 0);
        const duration = parseInt(entry.target.dataset.duration) || 1500;

        if (!Number.isFinite(from) || !Number.isFinite(to) || from > to) {
          return false;
        }

        const increment = to - from;
        const decimalPointLength = getDecimalPointLength(increment);
        const startTime = performance.now();

        const countUp = (timestamp) => {
          const elapsed = performance.now() - startTime;
          const countValue = (from + ((elapsed / duration) * increment)).toFixed(decimalPointLength);

          if (countValue >= to) {
            counterEle.innerText = to;
          } else {
            counterEle.innerText = parseFloat(countValue);
            requestAnimationFrame(countUp);
          }
        };

        requestAnimationFrame(countUp);
        entry.target.classList.add('is-visible');
      }
    });
  }

  event() {
    console.log('イベント');
  }
}

function getDecimalPointLength(number) {
  const str = number.toString();
  const index = str.indexOf('.');
  return index === -1 ? 0 : str.length - index - 1;
}

// -------------------------------------------------
// スクロール禁止
// -------------------------------------------------
let scrollTop = 0;

function scrollBan() {
  const body = $('html')[0];
  if (body.classList.contains('is-hidden')) {
    // スクロール開放
    body.style.top = '';
    body.classList.remove('is-hidden');
    setTimeout(function () {
      window.scrollTo(0, scrollTop);
    }, 10);
    setTimeout(function () {
      body.classList.add('scroll-smooth');
    }, 10);
  } else {
    // スクロール禁止
    scrollTop = window.scrollY;
    body.style.top = (scrollTop * -1) + 'px';
    body.classList.add('is-hidden');
    body.classList.remove('scroll-smooth');
  }
}
// スムーススクロール
(function() {
  $('a[href^="#"]').on('click', function(event) {
    var target = $(this.getAttribute('href'));
    var headerHeight = $('.js-header').outerHeight(); // js-headerクラスの高さを取得

    if( target.length ) {
      event.preventDefault();
      $('html, body').stop().animate({
        scrollTop: target.offset().top - headerHeight // スクロール位置を調整
      }, 500);
    }
  });
}());

(() => {

})();

//DOMContentLoaded
$(() => {
});

//images resources loaded
$(window).on('load', () => {

  $(window).trigger('loading');
});

//after loading animation
$(window).on('loading', () => {

  let imgParallax = new ImgParallax('js-parallax');
  let inviewEvent = new InviewEvent('js-inview');
  let formConvert = new FormConvert('js-convert');
  
  let pageTop = new PageTop();
  let numCountUp = new NumCountUp('js-count-up');
  let occupation = new Occupation('p-occupation');
  let about = new About('p-about');
  let entry = new Entry('p-entry');
  let interview = new Interview('s-interview');
  let rectuitments = new Recruitments('a-recruitments');
  let formErrorTxtControl = new FormErrorTxtControl('js-form');

  // 日本語のローカライズ設定
  $.datepicker.regional['ja'] = {
    closeText: '閉じる',
    prevText: '&#x3C;前',
    nextText: '次&#x3E;',
    currentText: '今日',
    monthNames: ['1月','2月','3月','4月','5月','6月',
    '7月','8月','9月','10月','11月','12月'],
    monthNamesShort: ['1月','2月','3月','4月','5月','6月',
    '7月','8月','9月','10月','11月','12月'],
    dayNames: ['日曜日','月曜日','火曜日','水曜日','木曜日','金曜日','土曜日'],
    dayNamesShort: ['日','月','火','水','木','金','土'],
    dayNamesMin: ['日','月','火','水','木','金','土'],
    weekHeader: '週',
    dateFormat: 'yy年 mm月 dd日',
    firstDay: 0,
    isRTL: false,
    showMonthAfterYear: true,
    yearSuffix: '年'
  };
  $.datepicker.setDefaults($.datepicker.regional['ja']);

  // Datepickerの初期化
  $("#datepicker").datepicker({
    changeYear: true,
    changeMonth: true,
    yearRange: "1900:2100",
    showButtonPanel: true
  });
});

document.addEventListener('alpine:init', () => {
  let headerMenuFixed = new HeaderMenuFixed('js-header');
});